import type { ComplaintStatus } from '../api/types';

export function StatusBadge({ status }: { status: ComplaintStatus }) {
  return <span className={`badge ${status.toLowerCase()}`}>{status}</span>;
}

export function SensitiveBadge({ sensitive }: { sensitive: number | boolean }) {
  if (!sensitive) return null;
  return <span className="badge sensitive">Sensitive</span>;
}

/**
 * RG 271 sets a 30-calendar-day maximum for an IDR response. This flags a
 * complaint that has passed that date without one.
 */
export function OverdueBadge({ overdue }: { overdue: number | boolean }) {
  if (!overdue) return null;
  return <span className="badge overdue">IDR overdue</span>;
}
